import { CareemLocationIcon } from 'assets/icons';
import React from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div`
  display: flex;
  padding: 24px 16px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.lightDarkGray};
  margin-top: 6px;
`;

const StyledMessageText = styled.p`
  color: ${({ theme }) => theme.colors.darkStaleGray};
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.1px;
`;

const EmptyAddressesList = () => (
  <StyledContainer>
    <CareemLocationIcon />
    <StyledMessageText>Search for your apartment building, villa, office, or hotel address</StyledMessageText>
  </StyledContainer>
);

export default EmptyAddressesList;
